import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
const CustomDateRangePicker = ({ dateRange, onChange, placeholderText, className, components }) => {
    const [startDate, endDate] = dateRange || [null, null];

    return (
        <DatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={onChange}
            placeholderText={placeholderText}
            className={className}
            showYearDropdown={true}
            scrollableYearDropdown={true}
            showMonthDropdown={true}
            useShortMonthInDropdown={true}
        />
    )
}
export default CustomDateRangePicker
